const userInteractionListener = (callback) => {
  let isInteractionDetected = false;

  const invokeCallback = () => {
    if (!isInteractionDetected) {
      isInteractionDetected = true;
      callback();
    }
  };

  document.addEventListener("click", invokeCallback, { once: true });
  document.addEventListener("mousemove", invokeCallback, { once: true });
  document.addEventListener("keydown", invokeCallback, { once: true });
  document.addEventListener("touchstart", invokeCallback, { once: true });
  window.addEventListener("scroll", invokeCallback, { once: true });
  window.addEventListener("wheel", invokeCallback, { once: true });
};

export default userInteractionListener;
